import {EditDialog, EditDialogProps} from '@/components/refinedev/dialogs/edit-dialog';
import useDialogState from '@/hooks/useDialogState';
import {Button} from '@/shadcn_components/ui/button';
import {useCan} from '@refinedev/core';
import {PencilIcon, PlusCircleIcon} from 'lucide-react';
import React from 'react';

export type EditDialogButtonProps = {
  button?: React.ReactElement;
  label?: string;
  onSuccess?: (data) => void;
  // forceCan?: boolean;
  canParams?: any;
} & Partial<EditDialogProps>;

export const EditDialogButton = (props: EditDialogButtonProps) => {
  const {onSuccess, label, button, ...rest} = props;
  const {resource, id} = props;
  const dialogState = useDialogState();
  const {data: canAccess} = useCan({
    resource,
    action: 'update',
    params: {...props.canParams, id},
  });
  if (canAccess?.can === false) return null;
  // if ((canAccess?.can === false && forceCan === undefined) || forceCan === false) return null;

  return (
    <>
      {button ? (
        React.cloneElement(button, {onClick: dialogState.openDialog})
      ) : (
        <Button
          variant="ghost"
          size="icon"
          className="px-1 py-1 rounded-md text-blue-600 hover:bg-blue-50 hover:border-blue-600 hover:border hover:text-blue-600"
          onClick={dialogState.openDialog}
          title={label || 'Chỉnh sửa'}>
          <PencilIcon className="w-4 h-4" />
          {label}
        </Button>
      )}
      {dialogState.open && (
        <EditDialog
          dialogState={dialogState}
          {...rest}
          formProps={{
            ...rest.formProps,
            refineCoreProps: {
              onMutationSuccess: onSuccess,
              redirect: false,
              ...rest.formProps?.refineCoreProps,
            },
          }}
        />
      )}
    </>
  );
};
